import { Subject } from "rxjs";
import { toInterfaceArray } from "../helpers/helpers";
import { FactOfTheDay, IFactOfTheDay } from "./FactOfTheDay";
import { INewsArticle, NewsArticle } from "./NewsArticle";
import { IWordpressPost, WordpressPost } from "./WordpressPost";

export class InfoHubFavorites {
    
    posts: WordpressPost[];
    news: NewsArticle[];
    facts: FactOfTheDay[];
    
    //ChangeTracking
    public changedSubject: Subject<boolean> = new Subject<boolean>();

    //check if already added to favorites
    added(id: string): boolean{
        return(
            (this.posts.find(post => post.id.toString() == id) != undefined)
            || (this.news.find(news => news.url == id) != undefined)
            || (this.facts.find(fact => fact.id == id) != undefined)
            );
    }

    togglePost(post: WordpressPost){
        if(!this.added(post.id.toString()))
            this.posts.push(post);
        else{
            const index = this.posts.findIndex(x => x.id == post.id)
            this.posts.splice(index, 1);
        }
        this.changedSubject.next(true);
    }
    toggleNews(news: NewsArticle){
        if(!this.added(news.url))
            this.news.push(news);
        else{
            const index = this.news.findIndex(x => x.url == news.url)
            this.news.splice(index, 1);
        }
        this.changedSubject.next(true);
    }
    toggleFact(fact: FactOfTheDay){
        if(!this.added(fact.id))
            this.facts.push(fact);
        else{
            const index = this.facts.findIndex(x => x.id == fact.id)
            this.facts.splice(index, 1);
        }
        this.changedSubject.next(true);
    }

    constructor(i?: IInfoHubFavorites){
        if(i){
            this.posts = [];
            i.posts.forEach(element => {
                this.posts.push(new WordpressPost(element));
            });
            this.facts = [];
            i.facts.forEach(element => {
                this.facts.push(new FactOfTheDay(element));
            });
            this.news = [];
            i.news.forEach(element => {
                this.news.push(new NewsArticle(element));
            });
        }
        if(!this.posts) this.posts = [];
        if(!this.facts) this.facts = [];
        if(!this.news) this.news = [];
    }

    toInterface(): IInfoHubFavorites {
        return { facts: toInterfaceArray(this.facts), news: toInterfaceArray(this.news), posts: toInterfaceArray(this.posts) };
    }
}

export interface IInfoHubFavorites {
    posts: IWordpressPost[];
    news: INewsArticle[];
    facts: IFactOfTheDay[];
}